import { useMemo } from 'react';
import { FEATURES, FeatureName, getCurrentEnvironment } from '../config/features';

export const useFeatureFlag = () => {
  const currentEnvironment = useMemo(() => getCurrentEnvironment(), []);
  
  const isFeatureEnabled = (featureName: FeatureName): boolean => {
    const feature = FEATURES[featureName];
    if (!feature) {
      console.warn(`🏁 Feature "${featureName}" not found in configuration`);
      return false;
    }
    
    const isEnabled = feature[currentEnvironment];
    
    // Логируем в dev режиме
    if (currentEnvironment === 'dev') {
      console.log(`🏁 Feature "${featureName}": ${isEnabled ? 'ENABLED' : 'DISABLED'} in ${currentEnvironment}`);
    }
    
    return isEnabled;
  };
  
  const getFeatureDescription = (featureName: FeatureName): string | undefined => {
    return FEATURES[featureName]?.description;
  };
  
  return {
    currentEnvironment,
    isFeatureEnabled,
    getFeatureDescription
  };
};
